import React from 'react';
import classNames from 'classnames';

import { getQueryParam } from 'utils/url';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import LESSON_STATES from 'constants/lesson_states';

const getStateToDisplay = (state, contentType, isTabbedView) => {
  switch (state) {
    case LESSON_STATES.PUBLISHED:
      return t('lesson_overview.published');
    case LESSON_STATES.DRAFT:
      return t('lesson_overview.draft');
    case LESSON_STATES.NEW_VERSION_PENDING: {
      if (!isTabbedView) {
        return t('lesson_overview.published_unpublished_draft_no_emphasis');
      }
      if (contentType.includes('draft')) {
        return t('lesson_overview.draft');
      }
      return t('lesson_overview.published');
    }
    default:
      return null;
  }
};

export default function AdvancedSearchResultCardStatus({ state, contentType }) {
  const queryParam = getQueryParam(window.location.href, 'query');

  if (!state) {
    return null;
  }

  return (
    <div className="d-f fd-r">
      <div className="AdvancedSearchResultCard-status-bubble-container d-f ai-c mr-8">
        <div
          className={classNames('AdvancedSearchResultCard-status-bubble ml-1', {
            'AdvancedSearchResultCard-status-bubble--published':
              state === LESSON_STATES.PUBLISHED,
            'AdvancedSearchResultCard-status-bubble--draft':
              state === LESSON_STATES.DRAFT,
            'AdvancedSearchResultCard-status-bubble--unpublished-draft':
              state === LESSON_STATES.NEW_VERSION_PENDING,
          })}
        />
      </div>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
        {getStateToDisplay(state, contentType, !!queryParam)}
      </Text>
    </div>
  );
}
